import { createContext } from 'react';
import {
  makeApiProvider,
  useApiQuery,
} from '@pflegenavi/shared-frontend/platform';
import type {
  IServiceProviderAppPhoenixApi,
  GetResidentListPhoenixParams,
} from './api';
import { ServiceProviderAppPhoenixApi } from './api';
import type { ResidentState } from '@pflegenavi/shared/api';
import type {
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import type { PhoenixResident } from './api';

const ApiContext = createContext<IServiceProviderAppPhoenixApi | undefined>(
  undefined
);

const {
  useApi: useServiceProviderAppPhoenixApi,
  ApiProvider: ServiceProviderAppPhoenixApiProvider,
} = makeApiProvider({
  name: 'ServiceProviderAppPhoenix',
  ApiContext,
  newApi: (tenantId, auth, apiUrl) =>
    new ServiceProviderAppPhoenixApi(tenantId, auth, apiUrl),
});

export {
  useServiceProviderAppPhoenixApi,
  ServiceProviderAppPhoenixApiProvider,
  ApiContext as ServiceProviderAppPhoenixApiContext,
};

export type { IServiceProviderAppPhoenixApi };
export * from './api';

export const GET_RESIDENT_LIST_PHOENIX_KEY = (
  tenant: string,
  nursingHomeId: string,
  residentStates?: ResidentState[],
  residentIds?: string[]
): QueryKey => [
  'get-resident-list-phoenix',
  tenant,
  nursingHomeId,
  {
    residentStates,
    residentIds,
  },
];

export const useServiceProviderResidentListPhoenix = (
  params: GetResidentListPhoenixParams,
  options?: Omit<
    UseQueryOptions<PhoenixResident[], unknown>,
    'queryFn' | 'queryKey'
  >
): UseQueryResult<PhoenixResident[], unknown> => {
  return useApiQuery(
    useServiceProviderAppPhoenixApi,
    GET_RESIDENT_LIST_PHOENIX_KEY(
      params.tenant,
      params.nursingHomeId,
      params.residentStates,
      params.residentIds
    ),
    (api) => {
      return api.getResidentList({ params });
    },
    options
  );
};
